var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.modalNewPlayer)?_c('div',[_c('NewPlayerJoinedDialog',{attrs:{"newPlayerNickname":_vm.modalNewPlayerNickname}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }